export default "__VITE_ASSET__BmoMnO_L__"